import { useState, useEffect } from "react";
import { Video } from "lucide-react";
import Layout from "@/components/layout/Layout";
import PageHero from "@/components/shared/PageHero";
import { VideoCard, VideoCardSkeleton } from "@/components/shared/VideoCard";
import { AdBanner } from "@/components/shared/AdPlaceholder";
import axios from "axios";
import { API } from "@/App";

export default function VideosPage() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(`${API}/public/videos?limit=20`);
        setVideos(response.data.items);
      } catch (error) {
        console.error("Error fetching videos:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchVideos();
  }, []);

  return (
    <Layout>
      {/* Hero */}
      <PageHero
        section="videos"
        title="Videos"
        subtitle="Explora Honduras a través de nuestros videos. Documentales, reportajes y contenido visual de nuestra región."
        badge="Multimedia"
        badgeIcon={Video}
      />

      {/* Grid */}
      <section className="py-12 md:py-16" data-testid="videos-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3, 4, 5, 6].map((i) => <VideoCardSkeleton key={i} />)}
            </div>
          ) : videos.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {videos.map((video) => (
                <VideoCard key={video.post_id} post={video} />
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <Video className="h-12 w-12 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500">No hay videos publicados aún</p>
            </div>
          )}
        </div>
      </section>

      {/* Ad Banner */}
      <section className="py-8 bg-gray-50">
        <AdBanner />
      </section>
    </Layout>
  );
}
